module.exports = __webpack_public_path__ + "static/media/darkblue2.0681c93a.png";